// 花园核心：世界观基底与通用约束
import gardenCorePromptRaw from './garden.core.prompt.md?raw';
// 紫苑：角色战斗设计规则
import asterCharacterCombatPromptRaw from './aster.character-combat.prompt.md?raw';
// 山茶：语义任务提议生成
import camelliaQuestOfferPromptRaw from './camellia.quest-offer.prompt.md?raw';
// 山茶：语义任务结算裁定
import camelliaSemanticQuestJudgePromptRaw from './camellia.semantic-quest-judge.prompt.md?raw';
// 桔梗：据点架构与房间结构设计
import dahliaSiteStructurePromptRaw from './dahlia.site-structure.prompt.md?raw';
// 小苍兰：角色对话编织
import freesiaProfilePromptRaw from './freesia.profile.prompt.md?raw';
// 石楠：会话摘要（短期记忆）
import heatherSessionSummaryPromptRaw from './heather.session-summary.prompt.md?raw';
// 石楠：阶段融合（多段旧记忆合并）
import heatherStageFusionPromptRaw from './heather.stage-fusion.prompt.md?raw';
// 石楠：阶段摘要（中期记忆主干）
import heatherStageSummaryPromptRaw from './heather.stage-summary.prompt.md?raw';
// 风信子：战斗叙事渲染
import hyacinthProfilePromptRaw from './hyacinth.profile.prompt.md?raw';
// 鸢尾：角色蓝图一次成型
import irisCharacterBlueprintPromptRaw from './iris.character-blueprint.prompt.md?raw';
// 常春藤：玩家选项生成与工具调度协议
import ivyProtocolPromptRaw from './ivy.protocol.prompt.md?raw';
// 百合：角色世界存在方式设计
import lilyCharacterPresencePromptRaw from './lily.character-presence.prompt.md?raw';
// 风铃草：据点内容填充（角色生成项与物品）
import verbenaSiteContentPromptRaw from './verbena.site-content.prompt.md?raw';

function normalizePrompt(raw: string): string {
  return raw.replace(/\r\n/g, '\n').trim();
}

// 花园核心：世界观基底与通用约束
export const GARDEN_CORE_PROMPT = normalizePrompt(gardenCorePromptRaw);
// 紫苑：角色战斗设计规则
export const ASTER_CHARACTER_COMBAT_PROMPT = normalizePrompt(asterCharacterCombatPromptRaw);
// 山茶：语义任务提议生成
export const CAMELLIA_QUEST_OFFER_PROMPT = normalizePrompt(camelliaQuestOfferPromptRaw);
// 山茶：语义任务结算裁定
export const CAMELLIA_SEMANTIC_QUEST_JUDGE_PROMPT = normalizePrompt(camelliaSemanticQuestJudgePromptRaw);
// 桔梗：据点架构与房间结构设计
export const DAHLIA_SITE_STRUCTURE_PROMPT = normalizePrompt(dahliaSiteStructurePromptRaw);
// 小苍兰：角色对话编织
export const FREESIA_PROFILE_PROMPT = normalizePrompt(freesiaProfilePromptRaw);
// 石楠：会话摘要（短期记忆）
export const HEATHER_SESSION_SUMMARY_PROMPT = normalizePrompt(heatherSessionSummaryPromptRaw);
// 石楠：阶段融合（多段旧记忆合并）
export const HEATHER_STAGE_FUSION_PROMPT = normalizePrompt(heatherStageFusionPromptRaw);
// 石楠：阶段摘要（中期记忆主干）
export const HEATHER_STAGE_SUMMARY_PROMPT = normalizePrompt(heatherStageSummaryPromptRaw);
// 风信子：战斗叙事渲染
export const HYACINTH_PROFILE_PROMPT = normalizePrompt(hyacinthProfilePromptRaw);
// 鸢尾：角色蓝图一次成型
export const IRIS_CHARACTER_BLUEPRINT_PROMPT = normalizePrompt(irisCharacterBlueprintPromptRaw);
// 常春藤：玩家选项生成与工具调度协议
export const IVY_TOOL_CALL_PROTOCOL_PROMPT = normalizePrompt(ivyProtocolPromptRaw);
// 百合：角色世界存在方式设计
export const LILY_CHARACTER_PRESENCE_PROMPT = normalizePrompt(lilyCharacterPresencePromptRaw);
// 风铃草：据点内容填充（角色生成项与物品）
export const VERBENA_SITE_CONTENT_PROMPT = normalizePrompt(verbenaSiteContentPromptRaw);
